// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5364":"4919cf38139a5641","6681":"960c14c6bff86c51"}[chunkId] + ".js";
};